<div *ngIf="isLoading" class="loading-container flex justify-center items-center">
  <mat-spinner [diameter]="40" [strokeWidth]="2"></mat-spinner>
</div>
<div class="container">
  <ng-container *ngIf="bundle$ | async as bundle">
    <h1 class="text-2xl my-4">Purchase bundle</h1>
    <div class="purchase__body py-4 mt-9">
      <div class="purchase__details flex gap-10">
        <div class="basis-[300px] flex flex-col gap-2.5" [formGroup]="fg">
          <h3 class="flex justify-between title">
            <span>Bundle:</span>
            <span>{{ bundle.name | capitalizeCase }}</span>
          </h3>
          <div class="flex justify-end items-center text-xs">
            <mat-error *ngIf="quantity.value >= maximumQuantity">Maximum quantity exceeded</mat-error>
          </div>
          <div class="feature__item flex text-[#0000008a] justify-between items-center">
            <span>Billed</span>
            <mat-radio-group formControlName="billed" aria-label="Billed">
              <ng-container *ngFor="let bill of billeds">
                <mat-radio-button *ngIf="fg.get('billed').value === bill.key" [value]="bill.key">{{
                  bill.value
                }}</mat-radio-button>
              </ng-container>
            </mat-radio-group>
          </div>
          <mat-divider></mat-divider>
          <div>
            <h3>Features</h3>
            <ng-container *ngFor="let item of bundle.items">
              <div
                *ngIf="priceMap[item.numberSku || item.sku] !== null"
                class="feature__item flex bb text-[#0000008a] justify-between items-center"
              >
                <span>
                  <span [class.font-medium]="!!item.numberSku">{{ priceMap[item.numberSku || item.sku].skuName }}</span>
                  {{ !!item.numberSku ? ' number' : '' }} x
                  {{ item.quantity * (fg.get('quantity').value || 1) }}
                </span>
                <span>{{
                  priceMap[item.numberSku || item.sku].finalPrice * (item.quantity * (fg.get('quantity').value || 1))
                    | currency: currency
                }}</span>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="flex-auto">
          <ng-container *ngFor="let step of steps; let i = index">
            <div class="flex flex-col gap-4" *ngIf="step.active">
              <div class="flex items-center justify-between step__header">
                <h3 class="spacer title">{{ step.id.toString() | titlecase }}</h3>
                <div class="flex items-center content-center gap-2">
                  <span
                    *ngFor="let item of steps; let ix = index"
                    [ngClass]="i === ix ? 'bg-sky-500 text-white' : 'bg-gray-400'"
                    class="step-index"
                  >
                    {{ ix + 1 }}
                  </span>
                </div>
              </div>
              <mat-divider></mat-divider>
              <psh-select-number
                class="mt-2.5"
                *ngIf="step.id === stepName.number && step.active"
                [skuInfoMapping]="numberSkuMapping"
                (selectedConfirm)="selectedNumber()"
              ></psh-select-number>
              <psh-payment
                *ngIf="step.id === stepName.checkout && step.active"
                [totalPrice]="totalPrice"
                [wallet]="wallet"
                [totalActivationFee]="totalActivationFee"
                [hasNumber]="hasNumber"
                [(autoRenew)]="autoRenew"
                (changeProductQuantity)="changeQuantity($event)"
              ></psh-payment>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
  <psh-purchase-product *ngIf="!isBundle"> </psh-purchase-product>
  <div class="purchase__actions flex gap-10 justify-end">
    <div class="basis-[300px]"></div>
    <div class="flex-auto flex justify-between items-center">
      <ng-container *ngIf="activeStep === stepName.checkout">
        <button mat-stroked-button (click)="back()">
          <mat-icon *ngIf="steps.length > 1">arrow_back</mat-icon>
          {{ steps.length > 1 ? 'Back' : 'Cancel' }}
        </button>
        <ng-container *ngIf="wallet && (wallet.usableCredit >= totalPrice || totalPrice === 0); else topUp">
          <button mat-flat-button color="primary" (click)="payment()" [disabled]="isPaymentDisabled">Pay now</button>
        </ng-container>
        <ng-template #topUp>
          <button mat-flat-button color="primary" (click)="openTopup()">Topup</button>
        </ng-template>
      </ng-container>

      <ng-container *ngIf="activeStep === stepName.number">
        <button mat-stroked-button (click)="cancel()">Cancel</button>
        <button mat-flat-button [disabled]="fg?.invalid || !reservedAllNumber" color="primary" (click)="next()">
          Next
        </button>
      </ng-container>

      <ng-container *ngIf="activeStep === stepName.addons">
        <button mat-stroked-button (click)="cancel()">Cancel</button>
        <button mat-flat-button color="primary" (click)="next()">Next</button>
      </ng-container>
    </div>
  </div>
</div>
